/**
 * This file contains utilities for shape transformations
 * */

const interpolateString = (template, data) => {
  const braceRegex = /{(.*?)}/g;
  return template && template.replace(braceRegex, (_, key) => {
    let result = data;
    key.split('.').forEach((property) => {
      result = result ? result[property] : '';
    });
    return String(result);
  });
};

const createURLProxy = (urls) => {
  const proxyHandler = {
    get(obj, key) {
      if (key in obj) {
        const interpolate = (data) => interpolateString(obj[key], data);
        interpolate.toString = () => obj[key];
        return interpolate;
      }
      return key;
    },
  };
  return new Proxy(urls, proxyHandler);
};

const isObjectEqualShallow = (a, b) => {
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;

  for (let i = 0; i < keys.length; i += 1) {
    if (a[keys[i]] !== b[keys[i]]) return false;
  }
  return true;
};

const checkIsArrayEqualByKey = (array1, array2, key) => {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return true;
  }

  if (array1.length !== array2.length) {
    return false;
  }

  let isArrayEqual = true;

  for (let i = 0; i < array1.length; i += 1) {
    if (!isArrayEqual) {
      return false;
    }
    const foundItemIdx = array2.findIndex((ele) => ele[key] === array1[i][key]);
    if (foundItemIdx < 0) {
      isArrayEqual = false;
      break;
    }
  }

  return isArrayEqual;
};

/** obj should always be serializable */
const cloneDeep = (obj) => {
  let clone;
  try {
    clone = JSON.parse(JSON.stringify(obj));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return clone;
};

const getArrayFromNToM = (n, m) => {
  let res = [];
  for (let i = n; i <= m; i += 1) {
    res = [...res, i];
  }

  return res;
};

const formatDate = (date) => date && new Date(date).toLocaleDateString();

const formatDateTime = (date) => date && new Date(date).toLocaleString();

// This function convert bytes to larger unit.
const formatBytes = (bytes = 0, decimals = 0) => {
  const kiloByte = 1000;
  const decimal = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (!bytes) {
    return {
      size: 0,
      unit: sizes[0],
    };
  }

  const index = Math.floor(Math.log(bytes) / Math.log(kiloByte));

  return {
    size: parseFloat((bytes / kiloByte ** index).toFixed(decimal)),
    unit: sizes[index],
  };
};

export {
  interpolateString,
  createURLProxy,
  isObjectEqualShallow,
  checkIsArrayEqualByKey,
  cloneDeep,
  getArrayFromNToM,
  formatDate,
  formatDateTime,
  formatBytes,
};
